<script lang="ts">
	import type { CvrCompanyRow } from "$lib/types/cvr-company-row";
	import CvrWebsiteStatsDialog from "$lib/components/cvr-website-stats-dialog.svelte";
	import { Button } from "$lib/components/ui/button";

	let { rows = [] as CvrCompanyRow[] } = $props();
	let isWebsiteDialogOpen = $state(false);
	let selectedWebsiteRow = $state<CvrCompanyRow | null>(null);

	const formatDate = (value: string | null) => {
		if (!value) {
			return "-";
		}

		const asDate = new Date(value);
		if (Number.isNaN(asDate.getTime())) {
			return value;
		}

		return asDate.toLocaleDateString();
	};

	const openWebsiteDialog = (row: CvrCompanyRow) => {
		selectedWebsiteRow = row;
		isWebsiteDialogOpen = true;
	};

	const formatBranche = (row: CvrCompanyRow) => {
		const values = [row.nyesteHovedbranche, row.otherBrancheCodes]
			.filter((value) => value && value.trim().length > 0);

		return values.length > 0 ? values.join(", ") : "-";
	};

	const closeWebsiteDialog = () => {
		isWebsiteDialogOpen = false;
		selectedWebsiteRow = null;
	};
</script>

<div class="relative w-full overflow-x-auto rounded-md border">
	<table class="w-full caption-bottom text-sm">
		<thead class="[&_tr]:border-b">
			<tr class="border-b transition-colors hover:bg-muted/50 data-[state=selected]:bg-muted">
				<th class="text-foreground h-10 px-2 text-left align-middle font-medium whitespace-nowrap">CVR</th>
				<th class="text-foreground h-10 px-2 text-left align-middle font-medium whitespace-nowrap">Name</th>
				<th class="text-foreground h-10 px-2 text-left align-middle font-medium whitespace-nowrap">Address</th>
				<th class="text-foreground h-10 px-2 text-left align-middle font-medium whitespace-nowrap">Branche</th>
				<th class="text-foreground h-10 px-2 text-left align-middle font-medium whitespace-nowrap">Employees</th>
				<th class="text-foreground h-10 px-2 text-left align-middle font-medium whitespace-nowrap">Company form</th>
				<th class="text-foreground h-10 px-2 text-left align-middle font-medium whitespace-nowrap">Created</th>
				<th class="text-foreground h-10 px-2 text-left align-middle font-medium whitespace-nowrap">Protected</th>
				<th class="text-foreground h-10 px-2 text-left align-middle font-medium whitespace-nowrap">Website</th>
			</tr>
		</thead>
		<tbody class="[&_tr:last-child]:border-0">
			{#if rows.length === 0}
				<tr class="border-b transition-colors">
					<td class="p-2 align-middle text-muted-foreground" colspan="9">No companies found.</td>
				</tr>
			{:else}
				{#each rows as row (row.id)}
					<tr class="border-b transition-colors hover:bg-muted/50 data-[state=selected]:bg-muted">
						<td class="p-2 align-middle whitespace-nowrap">{row.cvrNumber}</td>
						<td class="p-2 align-middle">{row.name || "-"}</td>
						<td class="p-2 align-middle">{row.beliggenhedsadresse || "-"}</td>
						<td class="p-2 align-middle">{formatBranche(row)}</td>
						<td class="p-2 align-middle whitespace-nowrap">{row.antalAnsatte ?? "-"}</td>
						<td class="p-2 align-middle">{row.virksomhedsform || "-"}</td>
						<td class="p-2 align-middle whitespace-nowrap">{formatDate(row.createdDate)}</td>
						<td class="p-2 align-middle">{row.reklamebeskyttet ? "Yes" : "No"}</td>
						<td class="p-2 align-middle whitespace-nowrap">
							{#if !row.website}
								{#if row.websiteLookupFailed}
									<span class="text-destructive font-semibold">X</span>
								{:else}
									<span class="text-muted-foreground font-semibold">?</span>
								{/if}
							{:else if row.desktopPerformanceScore !== null}
								<Button
									type="button"
									size="sm"
									class="cursor-pointer"
									onclick={() => openWebsiteDialog(row)}
								>
									<span class="text-primary-foreground/80">Score</span>
									<span>{row.desktopPerformanceScore}/100</span>
								</Button>
							{:else}
								<span class="text-muted-foreground font-semibold">?</span>
							{/if}
						</td>
					</tr>
				{/each}
			{/if}
		</tbody>
	</table>
</div>

<CvrWebsiteStatsDialog
	open={isWebsiteDialogOpen}
	row={selectedWebsiteRow}
	onClose={closeWebsiteDialog}
/>
